import { useState, useCallback, useEffect } from "react"
import useEffectAsync from "../../hooks/useEffectAsync";
import fetcher from "../../utils/fetcher";
import MapItem from "./MapItem";
import { useGetPlotsQuery } from "/src/redux/plotsApi";

export default function MapItems({ map, selectedItem, onSelectItem, filterItems }) {

    // const [items, setItems] = useState([]);
    const { data: items, error, isLoading } = useGetPlotsQuery();
    const [itemsFiltered, setItemsFiltered] = useState([]);

    useEffect(()=>{
        if(Array.isArray(filterItems)){
            setItemsFiltered(items.filter(item=>filterItems.includes(item._id)));
        }else{
            setItemsFiltered(items);
        }
    },[items, filterItems]);

    return (
        <div>
            <ul className="hidden">
                {itemsFiltered && itemsFiltered.map(item => (
                    <li key={item._id}>
                        <MapItem 
                            map={map} 
                            _id={item._id} 
                            lat={item.lat} 
                            lng={item.lng} 
                            open={selectedItem === item._id} 
                            onOpen={(_id, e)=>onSelectItem(item, e)} 
                            onClose={(e)=>onSelectItem(null)} 
                        />
                    </li>
                ))}
            </ul>
        </div>
    )
}